// extracted by mini-css-extract-plugin
export var wrapperStyle = "featured_people_grid-module--wrapperStyle--Iz1kw";